// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","cover":"Card_cover__RMGfy","icon":"Card_icon__uNzFc"};